import { EmailSendTime, EmailType } from '@/client/system-emails';
import { TranslationFunctionType } from '@/common/types';

export const emailTypeOptions = (t: TranslationFunctionType) => [
  {
    label: t('generic.welcome'),
    value: EmailType.WELCOME,
  },
  {
    label: t('account.content.available'),
    value: EmailType.COURSE_AVAILABILITY,
  },
  {
    label: t('account.content.incompleteContentReminder'),
    value: EmailType.INCOMPLETE_COURSE_REMINDER,
  },
  {
    label: t('account.content.contentEnrollment'),
    value: EmailType.COURSE_ENROLLMENT,
  },
  {
    label: t('generic.welcome.sso'),
    value: EmailType.WELCOME_SSO,
  },
  {
    label: t('account.welcome.freeTrial'),
    value: EmailType.WELCOME_FREE_TRIAL,
  },
  {
    label: t('security.culture'),
    value: EmailType.SECURITY_CULTURE,
  },
  {
    label: t('security.culture.reminder'),
    value: EmailType.SECURITY_CULTURE_REMINDER,
  },
  {
    label: t('security.culture.upcomingSurvey'),
    value: EmailType.SECURITY_CULTURE_UPCOMING_SURVEY,
  },
  {
    label: t('user.reactivation'),
    value: EmailType.USER_REACTIVATION,
  },
  {
    label: t('account.managerReminder'),
    value: EmailType.MANAGER_REMAINDER,
  },
  {
    label: t('account.domains.title'),
    value: EmailType.DOMAIN_VERIFICATION,
  },
  {
    label: t('osint.email.type.scrapingComplete'),
    value: EmailType.OSINT_SCRAPING_COMPLETE,
  },
  {
    label: t('osint.email.type.scrapingFailed'),
    value: EmailType.OSINT_SCRAPING_FAILED,
  },
  {
    label: t('account.emails.adminTaskRequiredReminder'),
    value: EmailType.ADMIN_TASK_REQUIRED_REMINDER,
  },
  {
    label: t('account.emails.adminTaskGeneralReminder'),
    value: EmailType.ADMIN_TASK_GENERAL_REMINDER,
  },
  {
    label: t('account.freeTrialConverted'),
    value: EmailType.FREE_TRIAL_CONVERTED,
  },
  {
    label: t('phishing.followUp.emailType'),
    value: EmailType.PHISHING_FOLLOW_UP,
  },
  {
    label: t('pendingAccess.email.type.joined'),
    value: EmailType.PENDING_USER_JOINED,
  },
  {
    label: t('pendingAccess.email.type.approved'),
    value: EmailType.PENDING_USER_APPROVED,
  },
  {
    label: t('pendingAccess.email.type.denied'),
    value: EmailType.PENDING_USER_DENIED,
  },
];

export const getEmailTypesLabels = (
  t: TranslationFunctionType,
): { [key: string]: string } => ({
  [EmailType.WELCOME]: t('generic.welcome'),
  [EmailType.COURSE_AVAILABILITY]: t('account.content.available'),
  [EmailType.INCOMPLETE_COURSE_REMINDER]: t(
    'account.content.incompleteContentReminder',
  ),
  [EmailType.COURSE_ENROLLMENT]: t('account.content.contentEnrollment'),
  [EmailType.WELCOME_SSO]: t('generic.welcome.sso'),
  [EmailType.WELCOME_FREE_TRIAL]: t('account.welcome.freeTrial'),
  [EmailType.SECURITY_CULTURE]: t('security.culture'),
  [EmailType.SECURITY_CULTURE_REMINDER]: t('security.culture.reminder'),
  [EmailType.SECURITY_CULTURE_UPCOMING_SURVEY]: t(
    'security.culture.upcomingSurvey',
  ),
  [EmailType.USER_REACTIVATION]: t('user.reactivation'),
  [EmailType.MANAGER_REMAINDER]: t('account.managerReminder'),
  [EmailType.DOMAIN_VERIFICATION]: t('account.domains.title'),
  [EmailType.OSINT_SCRAPING_COMPLETE]: t('osint.email.type.scrapingComplete'),
  [EmailType.OSINT_SCRAPING_FAILED]: t('osint.email.type.scrapingFailed'),
  [EmailType.ADMIN_TASK_REQUIRED_REMINDER]: t(
    'account.emails.adminTaskRequiredReminder',
  ),
  [EmailType.ADMIN_TASK_GENERAL_REMINDER]: t(
    'account.emails.adminTaskGeneralReminder',
  ),
  [EmailType.FREE_TRIAL_CONVERTED]: t('account.freeTrialConverted'),
  [EmailType.PHISHING_FOLLOW_UP]: t('phishing.followUp.emailType'),
  [EmailType.PENDING_USER_JOINED]: t('pendingAccess.email.type.joined'),
  [EmailType.PENDING_USER_APPROVED]: t('pendingAccess.email.type.approved'),
  [EmailType.PENDING_USER_DENIED]: t('pendingAccess.email.type.denied'),
});

export const emailSendTimeOptions = (t: TranslationFunctionType) => [
  {
    label: t('system.email.type.config.userRegistration'),
    value: EmailSendTime.USER_REGISTRATION,
  },
  // {
  //   label: t('system.email.type.config.userRequest'),
  //   value: EmailSendTime.USER_REQUEST,
  // },
  {
    label: t('system.email.type.config.userEnrollment'),
    value: EmailSendTime.USER_ENROLLMENT,
  },
  {
    label: t('system.email.type.config.system'),
    value: EmailSendTime.SYSTEM,
  },
  {
    label: t('osint.email.type.scrapingComplete'),
    value: EmailSendTime.OSINT_SCRAPING_COMPLETE,
  },
  {
    label: t('osint.email.type.scrapingFailed'),
    value: EmailSendTime.OSINT_SCRAPING_FAILED,
  },
];
